import { hostsConfig, turnToConfig } from 'init/config'
import { loadBaseCss, loadPageCss, loadBaseJs, loadPageJs } from 'init/resource-loader'
import log from 'util/logger'

// This sets the path to the server so webpack knows how to load other chunks
// (dynamically loaded modules)
// NOTE: imports cannot go above this line unless they are already part of turnto.js
const path = process.env.NODE_ENV === 'development' ? '' : 'v5/widgets/'
__webpack_public_path__ = `${hostsConfig.protocol}://${hostsConfig.widgetsHost}/${path}`

interface IPagesConfig {
  [name: string]: {
    baseCssFilePath: string
    baseJsFilePath: string
    pageCssFilePath: string
    pageJsFilePath: { [locale: string]: string }
  }
}

function loadPage(pagesConfig: IPagesConfig) {
  const pageFilesConfig = pagesConfig[turnToConfig.pageId]
  if (!pageFilesConfig) {
    log.error(`Could not find configuration for pageId: ${turnToConfig.pageId}`)
    return
  }
  loadBaseCss(pageFilesConfig.baseCssFilePath)
  loadPageCss(pageFilesConfig.pageCssFilePath)
  loadBaseJs(pageFilesConfig.baseJsFilePath)
  if (!pageFilesConfig.pageJsFilePath[turnToConfig.locale]) {
    log.error(`Could not find a page configuration for locale: ${turnToConfig.locale}`)
    return
  }
  loadPageJs(pageFilesConfig.pageJsFilePath[turnToConfig.locale])
}

if (process.env.NODE_ENV === 'development') {
  // DO NOT REMOVE OR CHANGE THE loadPage LINE. The dev-pages-for-entry.js loader will replace that
  // with a pages object that is derived from the entry points listed in webpack.config.dev.js
  // loadPage({...})
}

export { loadPage }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/entry/turnto-entry.ts